var map = {
	"./labmem_text_share_en.png": "a841",
	"./labmem_text_share_jp.png": "c2e0",
	"./labmem_text_share_kr.png": "f56c",
	"./labmem_text_share_sc.png": "3960",
	"./labmem_text_share_tc.png": "e92a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3c08";